// import { useEffect, useState, useCallback } from "react";
// import Web3 from "web3";
// import { provider } from "./setup"; // Import provider from setup.js

// const WalletConnectComponent = ({ onWalletConnected, isOpen, onClose }) => {
//   const [web3, setWeb3] = useState(null);
//   const disconnectWallet = useCallback(async () => {
//     if (provider) {
//       try {
//         await provider.disconnect();
//         setWeb3(null);
//       } catch (error) {
//         console.error("Error disconnecting wallet:", error);
//       }
//     }
//   }, []);

//   useEffect(() => {
//     if (!isOpen) {
//       disconnectWallet();
//     }
//   }, [isOpen, disconnectWallet]);

//   useEffect(() => {
//     const connectWallet = async () => {
//       try {
//         if (!isOpen) return;

//         const web3Instance = new Web3(provider);
//         setWeb3(web3Instance);

//         const accounts = await provider.request({
//           method: "eth_requestAccounts",
//         });
//         const address = accounts.length > 0 ? accounts[0] : null;
//         if (address) {
//           onWalletConnected(address);
//           onClose();
//         } else {
//           console.error("No accounts found.");
//           onClose();
//         }
//       } catch (error) {
//         if (error.code === 4001) {
//           // Handle user rejection gracefully
//           console.log("Wallet connection request rejected by user");
//         } else {
//           // Log other errors
//           console.error("Wallet connection failed:", error);
//         }
//         onClose();
//       }
//     };

//     if (isOpen && !web3) {
//       connectWallet();
//     }

//     return () => {
//       if (provider) {
//         provider.removeAllListeners();
//         disconnectWallet();
//       }
//     };
//   }, [isOpen, onWalletConnected, web3, disconnectWallet, onClose]);

//   return null;
// };

// export default WalletConnectComponent;
import { useEffect, useState, useCallback } from "react";
import Web3 from "web3";
import WalletSelectionDialog from "../popups/wallet-selection-popup";
import {
  connectMetaMask,
  disconnectMetaMask,
  metamaskProvider,
} from "./metamask";
import {
  connectCoinbase,
  disconnectCoinbase,
  coinbaseSDK,
  coinbaseProvider,
} from "./coinbase";
import { connectTrustWallet } from "./trustwallet";

const WalletConnectComponent = ({ onWalletConnected, isOpen, onClose }) => {
  const [web3, setWeb3] = useState(null);
  const [selectedWallet, setSelectedWallet] = useState(null);

  const getProvider = () => {
    if (selectedWallet === "metamask") return metamaskProvider;
    if (selectedWallet === "coinbase") return coinbaseProvider;
    return null;
  };

  const disconnectWallet = useCallback(async () => {
    if (!selectedWallet) return;
    try {
      if (selectedWallet === "metamask") {
        await disconnectMetaMask();
      } else if (selectedWallet === "coinbase") {
        await disconnectCoinbase();
      }
      setWeb3(null);
      setSelectedWallet(null);
    } catch (error) {
      console.error("Error disconnecting wallet:", error);
    }
  }, [selectedWallet]);

  useEffect(() => {
    if (!isOpen) disconnectWallet();
  }, [isOpen, disconnectWallet]);

  useEffect(() => {
    const connectWallet = async () => {
      try {
        if (!isOpen || !selectedWallet) return;

        let address;
        if (selectedWallet === "metamask") {
          address = await connectMetaMask();
        } else if (selectedWallet === "coinbase") {
          address = await connectCoinbase();
        } else if (selectedWallet === "trustwallet") {
          address = await connectTrustWallet();
        }
        // const provider = getProvider();
        // const web3Instance = new Web3(provider.getProvider());
        // setWeb3(web3Instance);
        if (address) {
          onWalletConnected(address, selectedWallet);
          onClose();
        } else {
          console.error("No accounts found.");
          onClose();
        }
      } catch (error) {
        console.error("Wallet connection failed:", error);
        onClose();
      }
    };

    if (isOpen && selectedWallet && !web3) {
      connectWallet();
    }

    return () => {
      const provider = getProvider();
      provider?.removeAllListeners?.();
      disconnectWallet();
    };
  }, [
    isOpen,
    selectedWallet,
    web3,
    onWalletConnected,
    disconnectWallet,
    onClose,
  ]);

  return (
    <WalletSelectionDialog
      open={isOpen && !selectedWallet}
      onClose={onClose}
      onSelectWallet={setSelectedWallet}
    />
  );
};

export default WalletConnectComponent;
